import {
  Dispatch,
  SetStateAction,
  createContext,
  useMemo,
  useState,
  ReactNode,
} from "react";
import { IgPostDetailsDTO } from "@inkhunt/core";

export interface ImageDialogContextInterface {
  imageDialog: ImageDialogDefault;
  setImageDialog: Dispatch<SetStateAction<ImageDialogDefault>>;
}

interface ImageDialogDefault {
  isOpen: boolean;
  content: IgPostDetailsDTO;
}

export const EmptyImageDialog: ImageDialogDefault = {
  isOpen: false,
  content: {
    id: 0,
    mediaType: "",
    caption: "",
    mediaUrl: "",
    userId: 0,
    username: "",
    timestamp: "",
    likes: [],
    postChildren: [],
  },
};

const defaultState = {
  imageDialog: EmptyImageDialog,
  setImageDialog: (dialog: ImageDialogDefault) => {},
};

export const ImageDialogContext = createContext(defaultState);

type DialogProviderProps = {
  children: ReactNode;
};

export default function ImageDialogProvider({ children }: DialogProviderProps) {
  const [imageDialog, setImageDialog] =
    useState<ImageDialogDefault>(EmptyImageDialog);
  const value = useMemo(
    () => ({ imageDialog, setImageDialog }),
    [imageDialog]
  );
  return (
    <ImageDialogContext.Provider value={value}>
      {children}
    </ImageDialogContext.Provider>
  );
}
